"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgileBotAddedUserCard = void 0;
const adaptivecards_1 = require("adaptivecards");
const __1 = require("../../");
const commands_1 = require("../../_shared/commands");
const CardHelper_1 = require("../../_shared/utils/CardHelper");
const _1 = require(".");
const AgileBotAddedUserCard = () => {
    const card = __1.CardHelper.newCard();
    const container = __1.CardHelper.create(adaptivecards_1.Container, {
        spacing: adaptivecards_1.Spacing.ExtraLarge,
        style: adaptivecards_1.ContainerStyle.Emphasis,
    });
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        color: adaptivecards_1.TextColor.Accent,
        horizontalAlignment: adaptivecards_1.HorizontalAlignment.Center,
        size: adaptivecards_1.TextSize.Large,
        text: "👋 Hi There! Welcome to AgilePolly",
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    container.addItem(__1.CardHelper.create(adaptivecards_1.Image, {
        url: (0, CardHelper_1.getImageCardUrl)("GETTING_STARTED", "agile"),
    }));
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "To get started:",
        spacing: adaptivecards_1.Spacing.Large,
        weight: adaptivecards_1.TextWeight.Bolder,
        wrap: true,
    }));
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "1 - Navigate to the channel in the team you want to run the standup",
        wrap: true,
    }));
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: "2 - Add an AgilePolly tab to the channel",
        wrap: true,
    }));
    container.addItem(__1.CardHelper.create(adaptivecards_1.TextBlock, {
        text: '3 - Select "Create" from the AgilePolly tab to configure your standup!',
        wrap: true,
    }));
    card.addItem(container);
    card.addAction(__1.CardHelper.create(adaptivecards_1.OpenUrlAction, {
        title: "Learn more",
        url: _1.AGILE_LEARN_MORE_LINK,
    }));
    card.addAction((0, commands_1.DeleteCardAction)());
    return card;
};
exports.AgileBotAddedUserCard = AgileBotAddedUserCard;
//# sourceMappingURL=AgileBotAddedUserCard.js.map